var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { titleize, humanize } from 'underscore.string';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import ShipmentStore from 'stores/ShipmentStore';
import DocumentUploadStore from 'stores/DocumentUploadStore';
import { massUpdateActions } from 'constants/MassUpdates';
import uneditableReferenceNumbers from 'constants/UneditableReferenceNumbers';
import { getUpdateFieldForAction } from 'helpers/MassUpdates';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import { Trans, withTranslation } from 'react-i18next';
import { stopRequiresTrailer, getPickupEmptyStops, getPickupStops, getOffsitePickupStops, getOffsitePickupEmptyStops, getDeliverEmpty, getDeliverStops, getOffsiteDeliverStops, getOffsiteDeliverEmptyStops, getTimezone as getTimezoneHelper, } from 'helpers/stops';
import { getReasonCodesByQuery } from 'utils/ReasonCodesAPI';
import { ARRIVAL_STOP_TYPES } from 'constants/stops';
import { requiresReasonCapture } from 'helpers/shipments';
import { containerExists, trailerExists } from 'helpers/equipment';
import { isFutureDate } from 'common/helpers/dateUtils';
import { getAllCountryTimezones, getTimezones } from 'utils/Timezones';
import LoadingCircle from 'components/ui/LoadingCircle';
import { updateSealNumberOnStopReferenceNumbersBulk } from 'utils/ShipmentWebAPIUtils';
import { showToast } from 'stores/ToastStore';
import ShipmentsGroup from './ShipmentsGroup';
import StopsGroup from './StopsGroup';
import ProTip from '../../ui/ProTip';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import { getMissingReferenceNumbers, bulkAddShipmentReferenceNumbers, bulkAddTerminalHoldStatus, } from 'utils/ShipmentWebAPIUtils';
import { getReferenceNumberRequirements } from 'utils/UserServiceAPIUtils';
import { mapUserSpecificReferenceNumbers } from 'helpers/reference-numbers';
const TRANSITION_STATUS = {
    [massUpdateActions.SHIPMENT_ARRIVED]: 'arrived',
};
const PRO_TIP_MESSAGES = {
    [massUpdateActions.UPDATE_EMPTY_READY_FOR_PICKUP]: 'ENSURE_INFO_FILLED_BEFORE_APPLY_ALL_DOMESTIC_EXPORT_PICKUP_EXCLUDED',
};
const SEAL_NUMBER_MIN_LENGTH = 3;
const SEAL_NUMBER_MAX_LENGTH = 10;
const CHASSIS_ID_VALID_LENGTH = 10;
const WHITELISTED_SHIPMENT_STATUS = ['accepted', 'in_progress'];
const BLACKLISTED_SHIPMENT_STATUS = ['job_closed', 'job_canceled'];
const REQUIRES_ARRIVAL_INFO = 'requires_arrival_info';
const SHOW_ALL_STOPS = [massUpdateActions.UPDATE_APPOINTMENT_WINDOW];
const ENABLE_SHIPMENT_SAVE_ACTIONS = ['bulkApplyNotes', 'bulkClearTags'];
class MassUpdateModal extends Component {
    constructor(props) {
        super(props);
        this.getShipperReferenceNumbers = async () => {
            var _a, _b, _c;
            const shipments = ShipmentStore.getShipmentsForBulkUpdate();
            const shipperId = (_b = (_a = shipments === null || shipments === void 0 ? void 0 : shipments[0]) === null || _a === void 0 ? void 0 : _a.shipper) === null || _b === void 0 ? void 0 : _b._id;
            if (!shipperId) {
                return null;
            }
            const { t } = this.props;
            try {
                const userResponse = await getReferenceNumberRequirements(shipperId);
                const refData = ((_c = userResponse === null || userResponse === void 0 ? void 0 : userResponse.data) === null || _c === void 0 ? void 0 : _c.getReferenceNumberRequirementsQuery) || [];
                const referenceNumbers = refData === null || refData === void 0 ? void 0 : refData.map((refNum) => {
                    var _a;
                    return (Object.assign(Object.assign({}, refNum), { reference_number: (_a = refNum === null || refNum === void 0 ? void 0 : refNum.reference_number) === null || _a === void 0 ? void 0 : _a.slug }));
                });
                const mappedRefNumbers = mapUserSpecificReferenceNumbers(referenceNumbers);
                this.setState({ shipperReferenceNumbers: mappedRefNumbers });
            }
            catch (_error) {
                showToast(t('FAILED_TO_GET_SHIPPER_REFERENCE_NUMBERS'), null, 'error');
            }
        };
        this.onHide = () => {
            this.resetState();
            this.props.onHide();
        };
        this.getShipmentMetadata = (action, shipments) => {
            const field = getUpdateFieldForAction(action);
            const shipmentUpdates = shipments.reduce((current, shipment) => {
                if (shipment.order && shipment.order._id) {
                    current[shipment._id] = {
                        shipment_id: shipment.shipment_id,
                        [field]: shipment[field],
                    };
                }
                return current;
            }, {});
            return shipmentUpdates;
        };
        this.initModalData = (action, shipments) => {
            this.setState({
                action,
                modalGroupByShipment: getUpdateFieldForAction(action),
            }, () => {
                if (action === massUpdateActions.EDIT_LAST_FREE_DAY) {
                    ShipmentsActionCreators.getShipmentsForBulkLFD({
                        shipmentIds: shipments,
                    });
                }
                else {
                    ShipmentsActionCreators.getShipmentsById({
                        shipments,
                        include_all_jobs: action === 'bulkApplyAdminNotes',
                    });
                }
            });
        };
        this.handleCloseTip = (e) => {
            if (e)
                e.preventDefault();
            this.setState({
                proTipVisible: false,
            });
        };
        this.handleClearAll = (action) => () => {
            this.setState((prevState) => {
                const { groups: currentGroups } = prevState;
                const groupIndex = currentGroups.findIndex((g) => g.action === action);
                if (groupIndex === -1) {
                    return;
                }
                const group = _.cloneDeep(currentGroups[groupIndex]);
                group.stops = group.stops.map(resetMetadata);
                return {
                    groups: [
                        ...currentGroups.slice(0, groupIndex),
                        group,
                        ...currentGroups.slice(groupIndex + 1),
                    ],
                };
            });
        };
        this.handleClearAllForShipment = () => {
            this.setState((prevState) => {
                const { shipments } = prevState;
                const shipmentUpdates = shipments.reduce((updates, job) => {
                    updates = Object.assign(Object.assign({}, updates), { [job._id]: {
                            shipment_id: job.shipment_id,
                        } });
                    return updates;
                }, {});
                return { shipmentUpdates };
            });
        };
        this.handleRemoveShipment = (shipment) => {
            this.setState((prevState) => {
                const shipments = prevState.shipments.filter((s) => s._id !== shipment._id);
                const shipmentUpdates = prevState.shipmentUpdates;
                if (shipmentUpdates[shipment._id])
                    delete shipmentUpdates[shipment._id];
                return { shipments, shipmentUpdates };
            });
        };
        this.handleDocumentDrop = (action) => (stopId, jobId, file) => {
            this.setState((prevState) => {
                const { groups: currentGroups } = prevState;
                const groupIndex = currentGroups.findIndex((g) => g.action === action);
                if (groupIndex === -1) {
                    return {
                        pendingUploads: [...prevState.pendingUploads, `${action}_${stopId}`],
                    };
                }
                const group = _.cloneDeep(currentGroups[groupIndex]);
                const stopIndex = group.stops.findIndex((s) => s._id === stopId);
                if (stopIndex === -1) {
                    return {
                        pendingUploads: [...prevState.pendingUploads, `${action}_${stopId}`],
                    };
                }
                group.stops[stopIndex].meta.uploadPending = true;
                return {
                    pendingUploads: [...prevState.pendingUploads, `${action}_${stopId}`],
                    groups: [
                        ...currentGroups.slice(0, groupIndex),
                        group,
                        ...currentGroups.slice(groupIndex + 1),
                    ],
                };
            });
            ShipmentsActionCreators.uploadDocumentAndGetDocumentURI(file, jobId, stopId, action);
        };
        this.handleDocumentUploadStoreChange = (payload) => {
            const { t } = this.props;
            this.setState((prevState) => {
                const { groups: currentGroups, pendingUploads: currentPendingUploads } = prevState;
                const groupIndex = currentGroups.findIndex((g) => g.action === payload.action);
                if (groupIndex === -1) {
                    return;
                }
                const fileKey = `${payload.action}_${payload.stop_id}`;
                const pendingUploadIndex = currentPendingUploads.findIndex((u) => u === fileKey);
                const group = _.cloneDeep(currentGroups[groupIndex]);
                const stopIndex = group.stops.findIndex((s) => s._id === payload.stop_id);
                if (stopIndex === -1) {
                    return;
                }
                const uploadSuccessful = !_.isNull(payload.file);
                const meta = Object.assign(Object.assign({}, group.stops[stopIndex].meta), { uploadPending: false, filePath: [{ path: payload.path }], uri: [{ uri: payload.file }], type: [{ type: payload.type }] });
                if (uploadSuccessful) {
                    meta.applyAllDisabled = false;
                }
                group.stops[stopIndex].meta = meta;
                if (!uploadSuccessful) {
                    const items = [group.stops[stopIndex].shipment_id];
                    group.status = [];
                    group.status.push({
                        type: 'error',
                        message: t('DOCUMENT_UPLOAD_SHIPMENT_ERROR_TIP'),
                        items,
                    });
                }
                const groups = [
                    ...currentGroups.slice(0, groupIndex),
                    group,
                    ...currentGroups.slice(groupIndex + 1),
                ];
                let pendingUploads;
                if (pendingUploadIndex !== -1) {
                    pendingUploads = [
                        ...currentPendingUploads.slice(0, pendingUploadIndex),
                        ...currentPendingUploads.slice(pendingUploadIndex + 1),
                    ];
                }
                else {
                    pendingUploads = [...currentPendingUploads];
                }
                return { groups, pendingUploads };
            });
        };
        this.handleSaveAll = (action) => () => {
            this.setState((prevState, props) => {
                const { action: updateAction } = props;
                const { groups: currentGroups } = prevState;
                const groupIndex = currentGroups.findIndex((g) => g.action === action);
                if (groupIndex === -1) {
                    return {
                        groups: [...currentGroups],
                    };
                }
                const targetGroup = _.cloneDeep(currentGroups[groupIndex]);
                this.validateStops(targetGroup);
                if (targetGroup.saveInProgress) {
                    this.doBulkAction(updateAction, targetGroup);
                }
                return {
                    groups: [
                        ...currentGroups.slice(0, groupIndex),
                        targetGroup,
                        ...currentGroups.slice(groupIndex + 1),
                    ],
                };
            });
        };
        this.handleShipmentsQueryUpdate = async () => {
            const shipments = ShipmentStore.getShipmentsForBulkUpdate();
            const { action } = this.props;
            const filteredShipments = this.getFilteredShipmentsBasedOnAction(action, shipments);
            if (filteredShipments) {
                this.setState((prevState) => {
                    if (prevState.modalGroupByShipment) {
                        const shipmentUpdates = this.getShipmentUpdateData(prevState.action, filteredShipments);
                        return { shipments: filteredShipments, shipmentUpdates };
                    }
                    return { shipments: filteredShipments };
                }, () => {
                    this.refreshGroups();
                });
            }
        };
        this.bulkSaveStops = async (group) => {
            const payload = mapStopCompleteRequest(group.stops);
            if (!payload.length)
                return;
            await this.bulkUpdateShipmentReferenceNumbers();
            if (ARRIVAL_STOP_TYPES.includes(group.action)) {
                ShipmentsActionCreators.arrivedMassStops(group.action, payload);
            }
            else {
                ShipmentsActionCreators.completeMassStops(group.action, payload);
            }
            const sealNumberPayload = group.stops
                .filter((x) => { var _a; return (_a = x.meta) === null || _a === void 0 ? void 0 : _a.sealNumberChanged; })
                .map((x) => {
                var _a;
                return {
                    shipmentId: x.job_id,
                    stopId: x._id,
                    sealNumber: (_a = x.meta) === null || _a === void 0 ? void 0 : _a.sealNumber,
                };
            });
            if (!sealNumberPayload.length)
                return;
            updateSealNumberOnStopReferenceNumbersBulk(sealNumberPayload).catch((e) => console.log('Error updating ref numbers', e));
        };
        this.bulkSaveAppointmentWindows = (group) => {
            const payload = mapAppointmentUpdateRequest(group.stops);
            if (payload.length > 0) {
                ShipmentsActionCreators.updateMassShipmentStopScheduling(group.action, payload);
            }
        };
        this.bulkTransitionShipmentsToArrived = () => {
            this.setState({ saving: true }, () => {
                const { action, shipmentUpdates } = this.state;
                const status = TRANSITION_STATUS[action];
                const body = Object.keys(shipmentUpdates).reduce((update, shipment) => {
                    const { arrival_date } = shipmentUpdates[shipment];
                    update.shipmentIds.push(shipment);
                    update.meta[shipment] = { arrival_date };
                    return update;
                }, { shipmentIds: [], meta: {} });
                body.status = status;
                if (body.shipmentIds.length) {
                    ShipmentsActionCreators.bulkTransitionShipmentsToArrived(body);
                }
            });
        };
        this.bulkUpdateShipments = () => {
            const { action, shipmentUpdates } = this.state;
            const field = getUpdateFieldForAction(action);
            const updates = Object.keys(shipmentUpdates).map((key) => {
                return {
                    job_id: key,
                    updates: { [field]: shipmentUpdates[key][field] },
                    meta: {},
                };
            });
            ShipmentsActionCreators.bulkUpdateDates(updates);
        };
        this.bulkClearTags = () => {
            const { action, shipments } = this.state;
            const field = getUpdateFieldForAction(action);
            const updates = shipments === null || shipments === void 0 ? void 0 : shipments.map(({ _id: job_id }) => ({
                job_id,
                updates: { [field]: [] },
            }));
            ShipmentsActionCreators.bulkUpdateShipments(updates);
        };
        this.bulkAddTags = () => {
            const { action, shipmentUpdates, shipments } = this.state;
            const { t } = this.props;
            const field = getUpdateFieldForAction(action);
            const fieldToUpdate = 'tags';
            const emptyNewTagsId = [];
            const updates = [];
            shipments.forEach((shipment) => {
                var _a, _b, _c;
                const jobId = shipment._id;
                const oldTags = ((_a = shipment === null || shipment === void 0 ? void 0 : shipment[fieldToUpdate]) === null || _a === void 0 ? void 0 : _a.filter((tag) => tag)) || [];
                const newTags = ((_c = (_b = shipmentUpdates === null || shipmentUpdates === void 0 ? void 0 : shipmentUpdates[jobId]) === null || _b === void 0 ? void 0 : _b[field]) === null || _c === void 0 ? void 0 : _c.filter((tag) => tag)) || [];
                if (newTags.length === 0) {
                    emptyNewTagsId.push({
                        shipment_id: shipment.shipment_id,
                        id: jobId,
                    });
                }
                else {
                    updates.push({
                        job_id: jobId,
                        updates: {
                            [fieldToUpdate]: [...oldTags, ...newTags],
                        },
                    });
                }
            });
            if (emptyNewTagsId.length) {
                const shipmentUpdateResults = [
                    {
                        type: 'error',
                        message: t('SHIPMENTS_UPDATE_FAILURE_TIP'),
                        items: emptyNewTagsId.map(({ shipment_id }) => `${t('EMPTY_TAGS_FIELD')} ${shipment_id}`),
                        job_ids: emptyNewTagsId.map(({ id }) => id),
                    },
                ];
                this.setState({ shipmentUpdateResults });
            }
            else {
                ShipmentsActionCreators.bulkUpdateShipments(updates);
                this.setState({ shipmentUpdateResults: [] });
            }
        };
        this.bulkAddTerminalHoldStatusFn = async () => {
            const { action, shipmentUpdates, shipments } = this.state;
            const { t } = this.props;
            const field = getUpdateFieldForAction(action);
            const fieldToUpdate = 'terminal_hold_status';
            const emptyTerminalHoldStatusId = [];
            const updates = [];
            shipments.forEach((shipment) => {
                var _a, _b;
                const jobId = shipment._id;
                const newTerminalHoldStatus = ((_b = (_a = shipmentUpdates === null || shipmentUpdates === void 0 ? void 0 : shipmentUpdates[jobId]) === null || _a === void 0 ? void 0 : _a[field]) === null || _b === void 0 ? void 0 : _b.filter((terminalHold) => Boolean(terminalHold))) || [];
                if (newTerminalHoldStatus.length === 0) {
                    emptyTerminalHoldStatusId.push({
                        shipment_id: shipment.shipment_id,
                        id: jobId,
                    });
                }
                else {
                    updates.push({
                        job_id: jobId,
                        updates: {
                            [fieldToUpdate]: newTerminalHoldStatus,
                        },
                    });
                }
            });
            if (emptyTerminalHoldStatusId.length) {
                const shipmentUpdateResults = [
                    {
                        type: 'error',
                        message: t('SHIPMENTS_UPDATE_FAILURE_TIP'),
                        items: emptyTerminalHoldStatusId.map(({ shipment_id }) => `${t('EMPTY_TERMINAL_HOLD_FIELD')} ${shipment_id}`),
                        job_ids: emptyTerminalHoldStatusId.map(({ id }) => id),
                    },
                ];
                this.setState({ shipmentUpdateResults });
            }
            else {
                try {
                    await bulkAddTerminalHoldStatus(updates);
                    showToast(t('SHIPMENTS_UPDATE_SUCCESS_TIP'), t('SHIPMENT_BULK_TERMINAL_HOLDS_SUCCESSFULLY_UPDATED'), 'success');
                    this.onHide();
                }
                catch (error) {
                    showToast(t('FAILED_ADD_TERMINAL_HOLDS'), { error: error.message }, 'error');
                }
            }
        };
        this.bulkAddReferenceNumbers = () => {
            const { t } = this.props;
            const { referenceNumberType } = this.state;
            try {
                const { action, shipmentUpdates, shipments } = this.state;
                const field = getUpdateFieldForAction(action);
                const referenceName = referenceNumberType.custom
                    ? referenceNumberType.customReferenceNumber
                    : referenceNumberType.name;
                const refNumber = {
                    referenceName,
                    editable: !uneditableReferenceNumbers.includes(referenceName),
                    isNew: true,
                };
                const updates = [];
                shipments.forEach((shipment) => {
                    var _a;
                    const jobId = shipment._id;
                    updates.push({
                        shipment: jobId,
                        referenceNumbers: [
                            Object.assign(Object.assign({}, refNumber), { referenceValue: (_a = shipmentUpdates === null || shipmentUpdates === void 0 ? void 0 : shipmentUpdates[jobId]) === null || _a === void 0 ? void 0 : _a[field] }),
                        ],
                        auditEvent: true,
                    });
                });
                if (updates === null || updates === void 0 ? void 0 : updates.length) {
                    ShipmentsActionCreators.bulkAddShipmentReferenceNumbers(updates);
                    this.setState({ shipmentUpdateResults: [] });
                }
                else {
                    showToast(t('NO_VALID_UPDATES_FOUND'), null, 'warning');
                }
            }
            catch (error) {
                showToast(t('FAILED_ADD_REF_NUMBERS'), { error: error.message }, 'error');
            }
        };
        this.bulkUpdateShipmentNotes = () => {
            const { action, shipmentUpdates } = this.state;
            const field = getUpdateFieldForAction(action);
            const updates = Object.keys(shipmentUpdates).map((key) => {
                return {
                    job_id: key,
                    updates: { [field]: shipmentUpdates[key][field] },
                };
            });
            ShipmentsActionCreators.bulkUpdateNotes(updates);
        };
        this.bulkUpdateShipmentReferenceNumbers = async () => {
            try {
                const { referenceNumberUpdates } = this.state;
                if ((featureEnabled(CONFIGURED_FEATURES.SSR) &&
                    Object.keys(referenceNumberUpdates)).length) {
                    const updates = [];
                    Object.keys(referenceNumberUpdates).forEach((shipment) => {
                        const referenceNumbers = [];
                        Object.keys(referenceNumberUpdates[shipment]).forEach((referenceName) => {
                            const shipmentUpdates = referenceNumberUpdates[shipment];
                            const referenceValue = shipmentUpdates[referenceName];
                            if (referenceValue) {
                                referenceNumbers.push({
                                    referenceName,
                                    referenceValue,
                                    editable: !uneditableReferenceNumbers.includes(referenceName),
                                });
                            }
                        });
                        if (referenceNumbers === null || referenceNumbers === void 0 ? void 0 : referenceNumbers.length) {
                            updates.push({
                                shipment,
                                referenceNumbers,
                            });
                        }
                    });
                    if (updates === null || updates === void 0 ? void 0 : updates.length) {
                        await bulkAddShipmentReferenceNumbers(updates);
                    }
                }
            }
            catch (e) {
                console.error('Failed to add shipment reference numbers: ', e.message);
                showToast('Failed to add shipment reference numbers', null, 'error');
            }
        };
        this.handleBulkShipmentUpdateChange = () => {
            const { t } = this.props;
            const { shipments, shipmentUpdates } = this.state;
            const shipmentUpdateResults = [];
            const { successes, errors } = ShipmentStore.getBulkShipmentUpdateResult();
            if (successes.length) {
                const items = successes.map((jobId) => shipmentUpdates[jobId].shipment_id || '');
                shipmentUpdateResults.push({
                    type: 'success',
                    message: t('SHIPMENTS_UPDATE_SUCCESS_TIP'),
                    items,
                });
            }
            if (errors.length) {
                const items = errors.map((jobId) => shipmentUpdates[jobId].shipment_id || '');
                shipmentUpdateResults.push({
                    type: 'error',
                    message: t('SHIPMENTS_UPDATE_FAILURE_TIP'),
                    items,
                });
            }
            this.setState({ shipmentUpdateResults, saving: false }, () => ShipmentsActionCreators.getShipmentsById({ shipments }));
        };
        this.handleBulkUpdateChange = () => {
            const bulkUpdateResult = ShipmentStore.getBulkUpdateResult();
            const { action, successes, errors } = bulkUpdateResult;
            const { t } = this.props;
            this.setState((prevState) => {
                const { groups: currentGroups } = prevState;
                const groupIndex = currentGroups.findIndex((g) => g.action === action);
                if (groupIndex === -1) {
                    return;
                }
                const group = _.cloneDeep(currentGroups[groupIndex]);
                group.saveInProgress = false;
                group.stops = group.stops.map((s) => (Object.assign(Object.assign({}, s), { meta: Object.assign(Object.assign({}, s.meta), { updated: false, isValid: true }) })));
                group.status = [];
                if (successes && successes.length) {
                    const items = successes.map((job) => job.shipment_id);
                    group.status.push({
                        type: 'success',
                        message: t('SHIPMENTS_UPDATE_SUCCESS_TIP'),
                        items,
                    });
                }
                if (errors && errors.length) {
                    const items = errors.map((job) => (job === null || job === void 0 ? void 0 : job.error) === 'EQUIPMENT_MISMATCH'
                        ? `${t('CHASSIS_EQUIPMENT_MISMATCH')} for ${(job === null || job === void 0 ? void 0 : job.shipment_id) || ''}`
                        : (job === null || job === void 0 ? void 0 : job.shipment_id) || '');
                    group.status.push({
                        type: 'error',
                        message: t('SHIPMENTS_UPDATE_FAILURE_TIP'),
                        items,
                    });
                }
                const groups = [
                    ...currentGroups.slice(0, groupIndex),
                    group,
                    ...currentGroups.slice(groupIndex + 1),
                ];
                // when all groups are successfully updated - we can close the modal
                if (groups.every((g) => {
                    var _a, _b;
                    return ((_a = g.status) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                        ((_b = g.status) === null || _b === void 0 ? void 0 : _b.every((s) => s.type === 'success'));
                }) ||
                    ((currentGroups === null || currentGroups === void 0 ? void 0 : currentGroups.length) === 1 &&
                        (successes === null || successes === void 0 ? void 0 : successes.length) > 0 &&
                        !(errors === null || errors === void 0 ? void 0 : errors.length))) {
                    showToast(t('SUCCESSFULLY_UPDATED'), null, 'success');
                    this.onHide();
                }
                return {
                    groups,
                };
            }, () => {
                const timeout = 2500;
                setTimeout(() => this.updateGroups(_.cloneDeep(successes)), timeout);
            });
        };
        this.handleApplyToAll = (action) => (stopId) => {
            const updateAction = this.getAction();
            switch (updateAction) {
                case massUpdateActions.COMPLETE_STOP:
                    this.applyAllForCompleteStops(action, stopId);
                    break;
                case massUpdateActions.UPDATE_APPOINTMENT_WINDOW:
                    this.applyAllForAppointmentWindows(action, stopId);
                    break;
                default:
            }
        };
        this.handleFieldChange = (action) => (stopId, field, value) => {
            this.setState((prevState) => {
                const { action: bulkAction } = prevState;
                const { groups: currentGroups } = prevState;
                const index = currentGroups.findIndex((g) => g.action === action);
                if (index === -1) {
                    return;
                }
                const targetGroup = _.cloneDeep(currentGroups[index]);
                const stopIndex = targetGroup.stops.findIndex((s) => s._id === stopId);
                if (field === 'date' && !targetGroup.stops[stopIndex].dateChanged) {
                    targetGroup.stops[stopIndex].dateChanged = true;
                }
                targetGroup.stops[stopIndex].meta[field] = value;
                if (field === 'sealNumber') {
                    targetGroup.stops[stopIndex].meta.sealNumberChanged = true;
                }
                const stop = targetGroup.stops[stopIndex];
                targetGroup.stops[stopIndex].meta.applyAllDisabled =
                    getApplyAllDisabled(bulkAction)(stop);
                const groups = [
                    ...currentGroups.slice(0, index),
                    targetGroup,
                    ...currentGroups.slice(index + 1),
                ];
                return {
                    groups,
                };
            });
        };
        this.handleFieldChangeForShipment = (jobId, field, value) => {
            this.setState((prevState) => {
                const { shipmentUpdates } = prevState;
                if (shipmentUpdates[jobId]) {
                    shipmentUpdates[jobId][field] = value;
                }
                else {
                    shipmentUpdates[jobId] = Object.assign(Object.assign({}, shipmentUpdates[jobId]), { [field]: value });
                }
                return { shipmentUpdates };
            });
        };
        this.handleAppointmentChange = (action) => (stopId, windowStart, windowEnd) => {
            const { groups: currentGroups } = this.state;
            const index = currentGroups.findIndex((g) => g.action === action);
            if (index === -1) {
                return;
            }
            const { action: bulkAction } = this.state;
            const targetGroup = _.cloneDeep(currentGroups[index]);
            const stopIndex = targetGroup.stops.findIndex((s) => s._id === stopId);
            targetGroup.stops[stopIndex].meta.window_start = windowStart;
            targetGroup.stops[stopIndex].meta.window_end = windowEnd;
            const stop = targetGroup.stops[stopIndex];
            targetGroup.stops[stopIndex].meta.applyAllDisabled =
                getApplyAllDisabled(bulkAction)(stop);
            const groups = [
                ...currentGroups.slice(0, index),
                targetGroup,
                ...currentGroups.slice(index + 1),
            ];
            this.setState({
                groups,
            });
        };
        this.handleAppointmentConfirmationChange = (action) => (stopId, confirmAppointment) => {
            const { groups: currentGroups } = this.state;
            const index = currentGroups.findIndex((g) => g.action === action);
            if (index === -1) {
                return;
            }
            const { action: bulkAction } = this.state;
            const groupSource = _.cloneDeep(currentGroups[index]);
            const stopIndex = groupSource.stops.findIndex((s) => s._id === stopId);
            const stop = groupSource.stops[stopIndex];
            stop.meta.confirm_appointment = confirmAppointment;
            stop.meta.applyAllDisabled = getApplyAllDisabled(bulkAction)(stop);
            const groups = [
                ...currentGroups.slice(0, index),
                groupSource,
                ...currentGroups.slice(index + 1),
            ];
            this.setState({
                groups,
            });
        };
        this.handleReferenceNumberTypeChange = (name, customReferenceNumber = '') => {
            this.setState({
                referenceNumberType: {
                    custom: name === 'custom',
                    name,
                    customReferenceNumber,
                },
            });
        };
        this.handleDeselectShipment = async (jobId) => {
            this.setState((prevState) => {
                const { shipments: currentShipments } = prevState;
                const index = currentShipments.findIndex((s) => s._id === jobId);
                if (jobId === -1) {
                    return;
                }
                const shipments = [
                    ...currentShipments.slice(0, index),
                    ...currentShipments.slice(index + 1),
                ].map((job) => (Object.assign(Object.assign({}, job), { updated: false })));
                return { shipments };
            }, () => this.refreshGroups());
        };
        this.applyFieldToAll = (field) => (jobId) => {
            this.setState((prevState) => {
                const { shipments, shipmentUpdates: currentUpdates } = prevState;
                if (jobId) {
                    const newValue = currentUpdates[jobId][field];
                    const shipmentUpdates = shipments.reduce((updates, job) => {
                        updates = Object.assign(Object.assign({}, updates), { [job._id]: {
                                shipment_id: job.shipment_id,
                                [field]: newValue,
                            } });
                        return updates;
                    }, {});
                    return { shipmentUpdates };
                }
            });
        };
        this.applyFieldToAllBelow = (field) => (jobId) => {
            this.setState((prevState) => {
                const { shipments, shipmentUpdates: currentUpdates } = prevState;
                if (jobId) {
                    const newValue = currentUpdates[jobId][field];
                    const jobIndex = shipments.findIndex((job) => job._id === jobId);
                    if (jobIndex === -1)
                        return null;
                    const shipmentUpdates = shipments.reduce((updates, job, index) => {
                        if (index > jobIndex) {
                            updates[job._id] = {
                                shipment_id: job.shipment_id,
                                [field]: newValue,
                            };
                        }
                        return updates;
                    }, Object.assign({}, currentUpdates));
                    return { shipmentUpdates };
                }
            });
        };
        this.handleReferenceNumberUpdate = (shipmentId, name, value) => {
            this.setState((currentState) => {
                const { referenceNumberUpdates: currentReferenceNumberUpdates } = currentState;
                let updatedReferenceNumbers = Object.assign({}, currentReferenceNumberUpdates);
                if (!updatedReferenceNumbers[shipmentId]) {
                    updatedReferenceNumbers[shipmentId] = { [name]: value };
                }
                else {
                    updatedReferenceNumbers[shipmentId] = Object.assign(Object.assign({}, updatedReferenceNumbers[shipmentId]), { [name]: value });
                }
                return Object.assign(Object.assign({}, currentState), { referenceNumberUpdates: updatedReferenceNumbers });
            });
        };
        // Note updates by reference
        this.validateStops = (group) => {
            const action = this.getAction();
            const { t } = this.props;
            switch (action) {
                case massUpdateActions.COMPLETE_STOP:
                    group.stops = this.validateStopCompletions(group.stops, group.action);
                    break;
                case massUpdateActions.UPDATE_APPOINTMENT_WINDOW:
                    group.stops = this.validateAppointmentWindows(group.stops);
                    break;
                default:
            }
            const errorStops = group.stops.filter((s) => !s.isValid);
            const items = errorStops.reduce((messages, stop) => messages.concat(...Object.values(stop.status)), []);
            if (items.length) {
                group.status = [
                    {
                        type: 'error',
                        message: t('CORRECT_ISSUES_AND_TRY_AGAIN'),
                        items,
                    },
                ];
                group.saveInProgress = false;
            }
            else {
                group.status = [];
                group.saveInProgress = true;
            }
        };
        this.getShipmentUpdateData = (action, shipments) => {
            switch (action) {
                case massUpdateActions.SHIPMENT_ARRIVED:
                case massUpdateActions.EDIT_ESTIMATED_ARRIVAL:
                case massUpdateActions.EDIT_ARRIVAL:
                case massUpdateActions.EDIT_DISCHARGE:
                case massUpdateActions.EDIT_LAST_FREE_DAY:
                case massUpdateActions.EDIT_ETA_TO_FINAL_RAIL_FACILITY:
                case massUpdateActions.EDIT_LFD_AT_RAIL_FACILITY:
                case massUpdateActions.BULK_APPLY_ADMIN_NOTES:
                case massUpdateActions.UPDATE_LAST_CUT:
                case massUpdateActions.UPDATE_EMPTY_RETURN:
                case massUpdateActions.UPDATE_EARLIEST_RETURN:
                case massUpdateActions.UPDATE_EARLIEST_GET_EMPTY:
                case massUpdateActions.UPDATE_EMPTY_READY_FOR_PICKUP:
                case massUpdateActions.UPDATE_REVIEW_DATE:
                case massUpdateActions.UPDATE_ACCOUNTING_REVIEW_DATE:
                case massUpdateActions.BULK_ADD_REFERENCE_NUMBERS:
                case massUpdateActions.BULK_CLEAR_TAGS:
                case massUpdateActions.BULK_ADD_TAGS:
                    return this.getShipmentMetadata(action, shipments);
                case massUpdateActions.BULK_ADD_TERMINAL_HOLDS:
                    return this.getShipmentMetadata(action, shipments);
                default:
                    return null;
            }
        };
        this.state = {
            shipments: [],
            groups: [],
            action: '',
            pendingUploads: [],
            proTipVisible: true,
            loading: true,
            shipmentUpdates: {},
            reasonCodes: [],
            referenceNumberUpdates: {},
            shipperReferenceNumbers: [],
            referenceNumberType: {
                name: '',
                custom: false,
                customReferenceNumber: '',
            },
        };
    }
    async componentDidMount() {
        await this.getAllReasonCodes();
        this.initModalData(this.props.action, this.props.shipments);
        ShipmentStore.addBulkUpdateChangeListener(this.handleBulkUpdateChange);
        ShipmentStore.addBulkShipmentUpdateChangeListener(this.handleBulkShipmentUpdateChange);
        ShipmentStore.addChangeListener(this.handleShipmentsQueryUpdate);
        ShipmentStore.addChangeListener(this.getShipperReferenceNumbers);
        ShipmentStore.addBulkShipmentDatesUpdateChangeListener(this.onHide);
        ShipmentStore.addBulkShipmentNotesUpdateChangeListener(this.onHide);
        ShipmentStore.addShipmentBulkTransitionSuccessChangeListener(this.onHide);
        DocumentUploadStore.addChangeListener(this.handleDocumentUploadStoreChange);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!nextProps.action) {
            return;
        }
        if (!this.props.show && nextProps.show) {
            this.initModalData(nextProps.action, nextProps.shipments);
        }
    }
    componentWillUnmount() {
        ShipmentStore.removeBulkUpdateChangeListener(this.handleBulkUpdateChange);
        ShipmentStore.removeBulkShipmentUpdateChangeListener(this.handleBulkShipmentUpdateChange);
        ShipmentStore.removeChangeListener(this.handleShipmentsQueryUpdate);
        ShipmentStore.removeChangeListener(this.getShipperReferenceNumbers);
        ShipmentStore.removeBulkShipmentDatesUpdateChangeListener(this.onHide);
        ShipmentStore.removeBulkShipmentNotesUpdateChangeListener(this.onHide);
        ShipmentStore.removeShipmentBulkTransitionSuccessChangeListener(this.onHide);
        DocumentUploadStore.removeChangeListener(this.handleDocumentUploadStoreChange);
    }
    async getAllReasonCodes() {
        try {
            const reasonCodes = await getReasonCodesByQuery({});
            this.setState({ reasonCodes });
        }
        catch (e) {
            console.log('Error: ', e.message);
            const { t } = this.props;
            showToast(t('FAILED_TO_GET_REASON_CODES'), null, 'error');
        }
    }
    getAction() {
        const { action } = this.state;
        return action;
    }
    getTitle() {
        const action = this.getAction();
        const { t } = this.props;
        switch (action) {
            case massUpdateActions.COMPLETE_STOP:
                return t('COMPLETE_A_STOP');
            case massUpdateActions.UPDATE_APPOINTMENT_WINDOW:
                return t('UPDATE_APPOINTMENT_WINDOW');
            case massUpdateActions.SHIPMENT_ARRIVED:
                return t('ARRIVE_SHIPMENTS');
            default:
                return '';
        }
    }
    async refreshGroups() {
        const state = Object.assign({}, this.state);
        this.setState({ loading: true });
        const groups = await groupStops(state);
        this.setState({ groups, loading: false });
    }
    resetState() {
        this.setState({
            shipments: [],
            groups: [],
            pendingUploads: [],
            proTipVisible: true,
        });
    }
    doBulkAction(updateAction, group) {
        switch (updateAction) {
            case massUpdateActions.COMPLETE_STOP:
                this.bulkSaveStops(group);
                break;
            case massUpdateActions.UPDATE_APPOINTMENT_WINDOW:
                this.bulkSaveAppointmentWindows(group);
                break;
            default:
        }
    }
    async updateGroups(updatedShipments) {
        const getNextState = async (currentState) => {
            const { action: bulkAction, shipments: currentShipments, groups: currentGroups, reasonCodes, } = currentState;
            const shipments = _.cloneDeep(currentShipments);
            const count = shipments.length;
            if (updatedShipments && updatedShipments.length) {
                const shipmentMap = {};
                // create a look up hash for the shipments
                for (let i = 0; i < count; i += 1) {
                    const job = shipments[i];
                    shipments[i].updated = false;
                    const id = job._id;
                    shipmentMap[id] = i;
                }
                updatedShipments.forEach((job) => {
                    const id = job._id;
                    if (typeof shipmentMap[id] !== 'undefined') {
                        const index = shipmentMap[id];
                        shipments[index] = job;
                        shipments[index].updated = true;
                    }
                });
            }
            const groups = await groupStops({
                shipments: shipments.filter((s) => s.current && !s.canceled),
                action: bulkAction,
                groups: currentGroups,
                reasonCodes,
            });
            return {
                shipments,
                groups,
                reasonCodes,
            };
        };
        const state = await getNextState(this.state);
        this.setState(state);
    }
    applyAllForCompleteStops(action, stopId) {
        // update the groups in the component state
        this.setState((prevState) => {
            const { groups: currentGroups } = prevState;
            const groupIndex = currentGroups.findIndex((g) => g.action === action);
            if (groupIndex === -1) {
                return;
            }
            const group = _.cloneDeep(currentGroups[groupIndex]);
            const stopIndex = group.stops.findIndex((s) => s._id === stopId);
            if (stopIndex === -1) {
                return;
            }
            const targetStop = group.stops[stopIndex];
            const { meta: { uri, filePath, signatory, date, message, reasonCode, reasonType, sealNumber, }, } = targetStop;
            group.stops = group.stops.map((stop, i) => {
                if (i === stopIndex) {
                    return stop;
                }
                if (uri && filePath) {
                    stop.meta.uri = uri;
                    stop.meta.filePath = filePath;
                }
                if (signatory) {
                    stop.meta.signatory = signatory;
                }
                if (date) {
                    stop.meta.date = date;
                    stop.dateChanged = true;
                }
                if (sealNumber) {
                    stop.meta.sealNumber = sealNumber;
                    stop.meta.sealNumberChanged = true;
                }
                const isApplyAllowed = stop.shipper_id === targetStop.shipper_id &&
                    stop.shipment_type === targetStop.shipment_type;
                if (message && isApplyAllowed) {
                    stop.meta.message = message;
                }
                if (reasonType && isApplyAllowed) {
                    stop.meta.reasonType = reasonType;
                }
                if (reasonCode && isApplyAllowed) {
                    stop.meta.reasonCode = reasonCode;
                }
                stop.meta.applyAllDisabled = false;
                return stop;
            });
            return {
                groups: [
                    ...currentGroups.slice(0, groupIndex),
                    group,
                    ...currentGroups.slice(groupIndex + 1),
                ],
            };
        });
    }
    applyAllForAppointmentWindows(action, stopId) {
        const groupIndex = this.state.groups.findIndex((g) => g.action === action);
        if (groupIndex === -1) {
            return;
        }
        const group = _.cloneDeep(this.state.groups[groupIndex]);
        const index = group.stops.findIndex((s) => s._id === stopId);
        if (index === -1) {
            return;
        }
        const targetStop = group.stops[index];
        group.stops = group.stops.map((s) => {
            const updatedStop = Object.assign({}, s);
            updatedStop.meta.window_start = targetStop.meta.window_start;
            updatedStop.meta.window_end = targetStop.meta.window_end;
            updatedStop.meta.confirm_appointment =
                targetStop.meta.confirm_appointment;
            updatedStop.meta.appointment = targetStop.meta.appointment;
            updatedStop.meta.applyAllDisabled = false;
            return updatedStop;
        });
        this.setState((prevState) => {
            return {
                groups: [
                    ...prevState.groups.slice(0, groupIndex),
                    group,
                    ...prevState.groups.slice(groupIndex + 1),
                ],
            };
        });
    }
    validateAppointmentWindows(stops) {
        const processedStops = stops.map((s) => {
            const { meta: { window_start, window_end }, } = s;
            const status = {};
            const { t } = this.props;
            if (!window_start) {
                status.window_start = t('APPOINTMENT_START_REQUIRED_FOR_SHIPMENT', {
                    shipmentId: s.shipment_id,
                });
            }
            if (!window_end) {
                status.window_end = t('APPOINTMENT_END_REQUIRED_FOR_SHIPMENT', {
                    shipmentId: s.shipment_id,
                });
            }
            if (window_start && window_end) {
                const windowStart = moment(window_start);
                const windowEnd = moment(window_end);
                if (windowStart.isAfter(windowEnd)) {
                    status.window_start = t('APPOINTMENT_START_SHOULD_BE_BEFORE_END_FOR_SHIPMENT', { shipmentId: s.shipment_id });
                }
            }
            if (Object.keys(status).length) {
                s.meta.isValid = false;
            }
            else {
                s.meta.isValid = true;
            }
            return Object.assign(Object.assign({}, s), { status });
        });
        return processedStops;
    }
    validateStopCompletions(stops, action) {
        const processedStops = stops.map((s) => {
            var _a, _b, _c, _d, _e, _f;
            const { meta: { signatory, uri, date, timezone, message, reasonCode, reasonType, sealNumber, }, empty, order_type, } = s;
            const status = {};
            const { t } = this.props;
            if (s.shipment_type === 'shorthaul' && action === 'deliver') {
                if (!signatory) {
                    status.signatory = t('SIGNATORY_MISSING_FOR_SHIPMENT', {
                        shipmentId: s.shipment_id,
                    });
                }
                if (!uri) {
                    status.uri = t('PROOF_OF_COMPLETION_MISSING_FOR_SHIPMENT', {
                        shipmentId: s.shipment_id,
                    });
                }
            }
            if (order_type === 'export' &&
                (action === 'pickup' || action === 'deliver') &&
                !empty &&
                (!sealNumber || sealNumber === '')) {
                status.sealNumber = t('SEAL_NUMBER_MISSING_W_SHIPMENT', {
                    shipmentId: s.shipment_id,
                });
            }
            if (sealNumber &&
                (sealNumber.length < SEAL_NUMBER_MIN_LENGTH ||
                    sealNumber.length > SEAL_NUMBER_MAX_LENGTH)) {
                status.sealNumber = t('SEAL_NUMBER_CHARACTER_COUNT_W_SHIPMENT', {
                    shipmentId: s.shipment_id,
                });
            }
            if (!date) {
                const action = humanize(s.action);
                status.date = t('TIME_OF_ACTION_MISSING_FOR_SHIPMENT', {
                    action: action,
                    shipmentId: s.shipment_id,
                });
            }
            // NOTE: Add tags in map with flags true/false
            const shipperTags = {
                requires_on_time_reason_code: ((s === null || s === void 0 ? void 0 : s.shipper_tags) || []).includes('requires_on_time_reason_code'),
                requires_late_early_reason_code: ((s === null || s === void 0 ? void 0 : s.shipper_tags) || []).includes('requires_late_early_reason_code'),
            };
            // NOTE: Prepare conditions for reason codes check
            const isRequiresReasonCapture = requiresReasonCapture(shipperTags, s, date);
            const isShipperReasonCodesPresent = (s === null || s === void 0 ? void 0 : s.isShipperReasonCodes) || false;
            const isReasonTypePresent = !_.isEmpty(reasonType || {});
            const isReasonCodePresent = !_.isEmpty(reasonCode || {});
            const isCommentRequired = (reasonType === null || reasonType === void 0 ? void 0 : reasonType.commentRequired) || false;
            const isCommentPresent = message === null || message === void 0 ? void 0 : message.length;
            // NOTE: Check values only if reason codes are required for shipments
            if (isShipperReasonCodesPresent || isRequiresReasonCapture) {
                if (isReasonTypePresent && isCommentRequired && !isCommentPresent) {
                    status.message = t('COMMENT_MISSING_FOR_SHIPMENT', {
                        shipmentId: s.shipment_id,
                    });
                }
                if (!isReasonTypePresent) {
                    status.reasonType = t('REASON_TYPE_MISSING_FOR_SHIPMENT', {
                        shipmentId: s.shipment_id,
                    });
                }
                if (!isReasonCodePresent) {
                    status.reasonCode = t('REASON_CODE_MISSING_FOR_SHIPMENT', {
                        shipmentId: s.shipment_id,
                    });
                }
            }
            // add logic to pass in the timezone
            if (isFutureDate(date, timezone.value)) {
                status.date = t('COMPLETION_DATE_FUTURE_WARNING_FOR_SHIPMENT', {
                    shipmentId: s.shipment_id,
                });
            }
            const isDrayageShipment = s.shipment_type === 'drayage';
            const requiresChassisAtCompletion = ((s === null || s === void 0 ? void 0 : s.shipper_tags) || []).includes('require_chassis_at_stop_completion');
            const hasChassisInput = !!((_c = (_b = (_a = s.meta) === null || _a === void 0 ? void 0 : _a.chassis) === null || _b === void 0 ? void 0 : _b.equipment_id) === null || _c === void 0 ? void 0 : _c.length);
            const hasInvalidChassisIdLength = ((_f = (_e = (_d = s.meta) === null || _d === void 0 ? void 0 : _d.chassis) === null || _e === void 0 ? void 0 : _e.equipment_id) === null || _f === void 0 ? void 0 : _f.length) !== CHASSIS_ID_VALID_LENGTH;
            if (isDrayageShipment &&
                requiresChassisAtCompletion &&
                hasInvalidChassisIdLength) {
                const errorMessage = t('ADD_CHASSIS_NBR_TO_COMPLETE_STOP', {
                    shipmentId: s.shipment_id,
                    chassis_length: CHASSIS_ID_VALID_LENGTH,
                });
                status.chassis = errorMessage;
            }
            if (hasChassisInput && hasInvalidChassisIdLength) {
                const errorMessage = t('CHASSIS_NBR_10_DIGIT_ERROR', {
                    shipmentId: s.shipment_id,
                    chassis_length: CHASSIS_ID_VALID_LENGTH,
                });
                status.chassis = errorMessage;
            }
            if (Object.keys(status).length) {
                s.meta.isValid = false;
            }
            else {
                s.meta.isValid = true;
            }
            return Object.assign(Object.assign({}, s), { status });
        });
        return processedStops;
    }
    disableShipmentSave() {
        const { action } = this.state;
        const field = getUpdateFieldForAction(action);
        if (ENABLE_SHIPMENT_SAVE_ACTIONS.includes(action)) {
            return false;
        }
        if (action === massUpdateActions.BULK_ADD_TAGS) {
            return !Object.keys(this.state.shipmentUpdates || []).some((job) => { var _a, _b; return (_b = (_a = this.state.shipmentUpdates) === null || _a === void 0 ? void 0 : _a[job][field]) === null || _b === void 0 ? void 0 : _b.length; });
        }
        return Object.keys(this.state.shipmentUpdates || []).some((job) => { var _a; return !((_a = this.state.shipmentUpdates) === null || _a === void 0 ? void 0 : _a[job][field]); });
    }
    disableShipmentClearAll() {
        const { action } = this.state;
        let disableClearAll = false;
        const field = getUpdateFieldForAction(action);
        if (action === massUpdateActions.BULK_ADD_TAGS) {
            disableClearAll = !Object.keys(this.state.shipmentUpdates || []).some((job) => { var _a, _b; return (_b = (_a = this.state.shipmentUpdates) === null || _a === void 0 ? void 0 : _a[job][field]) === null || _b === void 0 ? void 0 : _b.length; });
        }
        return disableClearAll;
    }
    getLocalizationSlug(action) {
        return Object.keys(massUpdateActions).find((key) => massUpdateActions[key] === action);
    }
    getModalDetails(action) {
        const field = getUpdateFieldForAction(action);
        const { t } = this.props;
        const localizationSlug = this.getLocalizationSlug(action);
        switch (action) {
            case massUpdateActions.SHIPMENT_ARRIVED:
                return {
                    modalTitle: t('EN_ROUTE'),
                    applyToAll: this.applyFieldToAll(field),
                    onSaveAll: this.bulkTransitionShipmentsToArrived,
                };
            case massUpdateActions.EDIT_ESTIMATED_ARRIVAL:
            case massUpdateActions.EDIT_ARRIVAL:
            case massUpdateActions.EDIT_DISCHARGE:
            case massUpdateActions.EDIT_LAST_FREE_DAY:
            case massUpdateActions.EDIT_ETA_TO_FINAL_RAIL_FACILITY:
            case massUpdateActions.EDIT_LFD_AT_RAIL_FACILITY:
            case massUpdateActions.UPDATE_LAST_CUT:
            case massUpdateActions.UPDATE_EARLIEST_RETURN:
            case massUpdateActions.UPDATE_EARLIEST_GET_EMPTY:
            case massUpdateActions.UPDATE_EMPTY_READY_FOR_PICKUP:
            case massUpdateActions.UPDATE_REVIEW_DATE:
            case massUpdateActions.UPDATE_EMPTY_RETURN:
            case massUpdateActions.UPDATE_ACCOUNTING_REVIEW_DATE:
                return {
                    modalTitle: titleize(t(localizationSlug)),
                    applyToAll: this.applyFieldToAll(field),
                    onSaveAll: this.bulkUpdateShipments,
                };
            case massUpdateActions.BULK_APPLY_ADMIN_NOTES:
                return {
                    modalTitle: titleize(t(localizationSlug)),
                    applyToAll: this.applyFieldToAll(field),
                    onSaveAll: this.bulkUpdateShipmentNotes,
                };
            case massUpdateActions.BULK_ADD_REFERENCE_NUMBERS:
                return {
                    modalTitle: titleize(t(localizationSlug)),
                    onSaveAll: this.bulkAddReferenceNumbers,
                    applyToAll: this.applyFieldToAllBelow(field),
                };
            case massUpdateActions.BULK_CLEAR_TAGS:
                return {
                    modalTitle: titleize(t(localizationSlug)),
                    onSaveAll: this.bulkClearTags,
                };
            case massUpdateActions.BULK_ADD_TAGS:
                return {
                    modalTitle: titleize(t(localizationSlug)),
                    onSaveAll: this.bulkAddTags,
                    applyToAll: this.applyFieldToAllBelow(field),
                };
            case massUpdateActions.BULK_ADD_TERMINAL_HOLDS:
                return {
                    modalTitle: titleize(t(localizationSlug)),
                    onSaveAll: this.bulkAddTerminalHoldStatusFn,
                    applyToAll: this.applyFieldToAllBelow(field),
                };
            default:
                return null;
        }
    }
    renderProTip() {
        if (!this.state.proTipVisible) {
            return null;
        }
        const { action } = this.props;
        const message = PRO_TIP_MESSAGES[action] || 'ENSURE_INFO_FILLED_BEFORE_APPLY_ALL';
        return (React.createElement(ProTip, { onClose: this.handleCloseTip },
            React.createElement(Trans, { i18nKey: message })));
    }
    renderLoading() {
        const { t } = this.props;
        return React.createElement(LoadingCircle, { text: `${t('LOADING')}` });
    }
    getFilteredShipmentsBasedOnAction(action, shipments) {
        if (['emptyReturnedDate', 'emptyReadyForPickupDate'].includes(action)) {
            return shipments.filter((shipment) => {
                const { order_type, order_movement_type } = shipment;
                if (order_type === 'export' ||
                    (order_type == 'domestic' && order_movement_type === 'pickup'))
                    return false;
                return true;
            });
        }
        return shipments;
    }
    renderShipments() {
        const { action, shipments } = this.state;
        const disableSave = this.disableShipmentSave();
        const disableClearAll = this.disableShipmentClearAll();
        const { t } = this.props;
        const modalDetails = this.getModalDetails(action);
        if (!modalDetails)
            return null;
        const { modalTitle, applyToAll, onSaveAll } = modalDetails;
        /* Un-Comment when ready to filter */
        // const enRouteShipments = shipments.filter(shipment => shipment.status === 'en_route');
        if (shipments.length === 0) {
            return (React.createElement("div", { className: "shadow p-4 bg-white flex justify-center" },
                React.createElement("div", { className: "flex justify-between" },
                    React.createElement("h4", { className: "mb-2 text-grey-darker" }, t('NO_VALID_SHIPMENTS_TO_UPDATE')))));
        }
        return (React.createElement(ShipmentsGroup, { key: this.state.action, updateAction: this.state.action, title: modalTitle, shipments: shipments, saving: this.state.saving, disableSave: disableSave, shipmentUpdates: this.state.shipmentUpdates, shipmentUpdateResults: this.state.shipmentUpdateResults, onFieldChange: this.handleFieldChangeForShipment, onApplyToAll: applyToAll, onClearAll: this.handleClearAllForShipment, onSaveAll: onSaveAll, onRemoveShipment: this.handleRemoveShipment, disableClearAll: disableClearAll, action: action, shipperReferenceNumbers: this.state.shipperReferenceNumbers, handleReferenceNumberTypeChange: this.handleReferenceNumberTypeChange, referenceNumberType: this.state.referenceNumberType }));
    }
    renderStopGroups() {
        const { groups, referenceNumberUpdates } = this.state;
        const { t } = this.props;
        if (groups.length === 0) {
            return (React.createElement("div", { className: "shadow p-4 bg-white flex justify-center" },
                React.createElement("div", { className: "flex justify-between" },
                    React.createElement("h4", { className: "mb-2 text-grey-darker" }, t('NO_ACTIVE_SHIPMENTS_TO_UPDATE')))));
        }
        return (React.createElement("div", null, groups.map((g) => (React.createElement(StopsGroup, { key: g.action, action: g.action, updateAction: this.state.action, title: titleize(humanize(g.action)), stops: g.stops, status: g.status, referenceNumberUpdates: referenceNumberUpdates, saveInProgress: g.saveInProgress, onClearAll: this.handleClearAll(g.action), onSaveAll: this.handleSaveAll(g.action), onApplyToAll: this.handleApplyToAll(g.action), onFieldChange: this.handleFieldChange(g.action), onDocumentDrop: this.handleDocumentDrop(g.action), onDeselectShipment: this.handleDeselectShipment, onAppointmentChange: this.handleAppointmentChange(g.action), onAppointmentConfirmationChange: this.handleAppointmentConfirmationChange(g.action), onReferenceNumberUpdate: this.handleReferenceNumberUpdate, actionsDisabled: this.state.pendingUploads.length > 0 })))));
    }
    render() {
        const { t } = this.props;
        const modalBody = this.state.modalGroupByShipment
            ? this.renderShipments()
            : this.renderStopGroups();
        return (React.createElement(Modal, { show: this.props.show, onHide: this.onHide, backdrop: "static", dialogClassName: "modal-override-large bg-grey-modal", keyboard: false },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null, this.getTitle())),
            React.createElement(Modal.Body, null,
                React.createElement("div", { className: "bg-grey-lightest" },
                    this.renderProTip(),
                    React.createElement("div", { className: "mt-4" }, this.state.loading ? this.renderLoading() : modalBody))),
            React.createElement(Modal.Footer, null,
                React.createElement("div", { className: "flex" },
                    React.createElement("div", { className: "w-3/4" }, "\u00A0"),
                    React.createElement("div", { className: "w-1/4 mt-3" },
                        React.createElement("div", { className: "flex justify-end button-group" },
                            React.createElement("button", { className: "block button secondary-action", onClick: () => this.onHide() }, titleize(t('CLOSE')))))))));
    }
}
MassUpdateModal.propTypes = {
    show: PropTypes.bool.isRequired,
    shipments: PropTypes.array,
    onHide: PropTypes.func.isRequired,
    action: PropTypes.string.isRequired,
};
MassUpdateModal.defaultProps = {
    shipments: [],
};
const whitelist = [
    '_id',
    'empty',
    'action',
    'equipments',
    'loads',
    'reference_numbers',
    'sequence',
    'window_start',
    'window_end',
    'signatory',
    'proof_of_completion',
    'location',
    'meta',
    'appointment_unconfirmed',
    'off_site',
    'status',
];
function getReasonCodesPayload(meta) {
    var _a, _b;
    const _meta = Object.assign(Object.assign({}, meta), { reason: meta === null || meta === void 0 ? void 0 : meta.reasonCode, reasonCode: (_a = meta === null || meta === void 0 ? void 0 : meta.reasonCode) === null || _a === void 0 ? void 0 : _a.code, reasonDescription: (_b = meta === null || meta === void 0 ? void 0 : meta.reasonCode) === null || _b === void 0 ? void 0 : _b.description });
    _meta.reasonType = undefined;
    return _meta;
}
function mapStopCompleteRequest(stops) {
    return stops.map((stop) => {
        if (!stop.meta.date) {
            stop.meta.date = moment().toISOString();
        }
        const meta = getReasonCodesPayload(stop.meta);
        return {
            shipment_id: stop === null || stop === void 0 ? void 0 : stop.shipment_id,
            job_id: stop.job_id,
            stop_id: stop._id,
            meta,
        };
    });
}
function mapAppointmentUpdateRequest(stops) {
    return stops.map((s) => ({
        stop_id: s._id,
        job_id: s.job_id,
        updates: {
            appointment: s.meta.appointment,
            window_start: s.meta.window_start,
            window_end: s.meta.window_end,
            appointment_unconfirmed: !s.meta.confirm_appointment,
        },
    }));
}
function addJobProperties(job) {
    const { _id: job_id, shipment_id, shipper_name, carrier_name, shipment_type, shipper: { tags: shipper_tags, _id: shipper_id }, order_type, reference_numbers, } = job;
    return (s) => (Object.assign(Object.assign({}, _.pick(s, whitelist)), { job_id,
        shipment_id,
        shipper_name,
        carrier_name,
        shipment_type,
        shipper_tags,
        shipper_id,
        order_type,
        reference_numbers }));
}
function isActiveStop(stop) {
    return !stop.complete && !stop.canceled;
}
function sortBySequence(stop) {
    return stop.sequence;
}
function getStopValues(stops) {
    return Object.keys(stops).map((key) => stops[key]);
}
function getFilteredShipments(_shipments, action) {
    /**
     * filter shipment which have status ["accepted","in_progress"] for complete stop;
     * filter shipment which haven't status ["job_closed","job_canceled"] for appointment update;
     *  */
    if (action === massUpdateActions.COMPLETE_STOP) {
        return _shipments.filter((shipment) => WHITELISTED_SHIPMENT_STATUS.includes(shipment.status));
    }
    if (action === massUpdateActions.UPDATE_APPOINTMENT_WINDOW) {
        return _shipments.filter((shipment) => !BLACKLISTED_SHIPMENT_STATUS.includes(shipment.status));
    }
    return _shipments;
}
function checkIfStopIsValidForCompleteStop(stop, shipment) {
    /**
     *  Shorthaul shipments are those who have shipment type -> [shorthaul/longhaul/dayrate]
     *  Drayage shipments are those who have shipment type -> [drayage/rail]
     *  */
    const shipmentType = shipment === null || shipment === void 0 ? void 0 : shipment.shipment_type;
    // if shipment type is not drayage don't check for equipments
    if (!isIntermodalShipmentType(shipmentType)) {
        return true;
    }
    const equipments = (stop === null || stop === void 0 ? void 0 : stop.equipments) || [];
    const hasContainer = containerExists(equipments);
    if (!hasContainer && !stopRequiresTrailer({ shipment })) {
        return false;
    }
    // if shipment stop equipment have required equipment type based on shipper tags.
    if (stopRequiresTrailer({ shipment }) && !trailerExists(equipments)) {
        return false;
    }
    return true;
}
async function getNextStops(currentState) {
    const { action, groups, shipments, reasonCodes } = currentState;
    const isActionCompleteStop = action === massUpdateActions.COMPLETE_STOP;
    const filteredShipments = getFilteredShipments(shipments, action);
    const nextStops = filteredShipments.reduce((stops, job) => {
        let actionableStops;
        if (SHOW_ALL_STOPS.includes(action)) {
            actionableStops = job.stops.filter(isActiveStop);
        }
        else {
            const activeStop = _.sortBy(job.stops, sortBySequence).find(isActiveStop);
            if (activeStop) {
                actionableStops = [activeStop];
            }
        }
        if (!actionableStops || !actionableStops.length) {
            return stops;
        }
        const shouldPreserveState = !job.updated;
        actionableStops.forEach((actionableStop) => {
            const isValidStop = isActionCompleteStop
                ? checkIfStopIsValidForCompleteStop(actionableStop, job)
                : true;
            if (!isValidStop) {
                return;
            }
            if (shouldPreserveState) {
                const group = groups.find((g) => g.action === actionableStop.action);
                if (group) {
                    const existingStop = group.stops.find((s) => s._id === actionableStop._id);
                    if (existingStop) {
                        stops[existingStop._id] = Object.assign(Object.assign({}, existingStop), { meta: Object.assign({}, existingStop.meta) });
                    }
                }
            }
            const mapped = [actionableStop]
                .map(addJobProperties(job))
                .map(attachStateToStops)
                .map(addReasonCodes(reasonCodes))
                .map(toggleApplyAllDisabled(action));
            if (mapped.length) {
                stops[mapped[0]._id] = mapped[0];
            }
        });
        return stops;
    }, {});
    return getStopValues(nextStops);
}
// NOTE: This function will add reason codes of shipper and default
function addReasonCodes(reasonCodes) {
    return function (stop) {
        const shipperReasonCodes = (reasonCodes === null || reasonCodes === void 0 ? void 0 : reasonCodes.find((item) => {
            var _a;
            return (item === null || item === void 0 ? void 0 : item.default) === false &&
                (item === null || item === void 0 ? void 0 : item.shipper) === (stop === null || stop === void 0 ? void 0 : stop.shipper_id) &&
                (item === null || item === void 0 ? void 0 : item.lineOfBusiness) === (stop === null || stop === void 0 ? void 0 : stop.shipment_type) &&
                ((_a = item === null || item === void 0 ? void 0 : item.categories) === null || _a === void 0 ? void 0 : _a.length);
        })) || {};
        const defaultReasonCodes = (reasonCodes === null || reasonCodes === void 0 ? void 0 : reasonCodes.find((item) => {
            var _a;
            return (item === null || item === void 0 ? void 0 : item.default) === true &&
                (item === null || item === void 0 ? void 0 : item.lineOfBusiness) === (stop === null || stop === void 0 ? void 0 : stop.shipment_type) &&
                ((_a = item === null || item === void 0 ? void 0 : item.categories) === null || _a === void 0 ? void 0 : _a.length);
        })) || {};
        return Object.assign(Object.assign({}, stop), { reasonCodes: { defaultReasonCodes, shipperReasonCodes } });
    };
}
function getTimezone(stop) {
    var _a, _b, _c, _d;
    const localTimezone = (_b = (_a = stop === null || stop === void 0 ? void 0 : stop.location[0]) === null || _a === void 0 ? void 0 : _a.location_timezone) !== null && _b !== void 0 ? _b : (_d = (_c = stop === null || stop === void 0 ? void 0 : stop.location[0]) === null || _c === void 0 ? void 0 : _c.market) === null || _d === void 0 ? void 0 : _d.timezone;
    // find appropriate timezone
    const tz = getAllCountryTimezones().find((t) => t.value === localTimezone);
    // match to unique timezone by name (PST, EDT, etc.)
    const uniqueTz = getTimezones().find((t) => t.name === tz.name);
    return uniqueTz;
}
const attachStateToStops = (s) => {
    var _a, _b;
    const pocDoc = s.documents
        ? s.documents.find((doc) => {
            return doc.key === 'proof_of_completion' && doc.show;
        })
        : null;
    const timezone = getTimezone(s);
    return Object.assign(Object.assign({}, s), { meta: {
            uri: pocDoc,
            filePath: '',
            signatory: s.signatory,
            date: findStopKey(s, 'status') === 'arrivalStops'
                ? getArrivalDefaultDate(s)
                : getCompleteDefaultDate(s),
            timezone: timezone,
            window_start: s.window_start,
            window_end: s.window_end,
            appointment: s.appointment || false,
            uploadPending: false,
            isValid: true,
            confirm_appointment: !s.appointment_unconfirmed,
            reasonCode: {},
            reasonType: {},
            sealNumber: (_b = (_a = s.reference_numbers) === null || _a === void 0 ? void 0 : _a.find((x) => x.name === 'seal_number')) === null || _b === void 0 ? void 0 : _b.value,
            sealNumberChanged: false,
        }, stop_status: s.status, status: {} });
};
function addReasonCodesToStops(stop, categoryName) {
    var _a, _b, _c, _d;
    const { reasonCodes } = stop;
    const shipperReasonCodes = ((_b = (_a = reasonCodes === null || reasonCodes === void 0 ? void 0 : reasonCodes.shipperReasonCodes) === null || _a === void 0 ? void 0 : _a.categories) === null || _b === void 0 ? void 0 : _b.find((category) => { var _a; return (category === null || category === void 0 ? void 0 : category.name) === categoryName && ((_a = category === null || category === void 0 ? void 0 : category.subCategories) === null || _a === void 0 ? void 0 : _a.length); })) || {};
    const defaultReasonCodes = ((_d = (_c = reasonCodes === null || reasonCodes === void 0 ? void 0 : reasonCodes.defaultReasonCodes) === null || _c === void 0 ? void 0 : _c.categories) === null || _d === void 0 ? void 0 : _d.find((category) => { var _a; return (category === null || category === void 0 ? void 0 : category.name) === categoryName && ((_a = category === null || category === void 0 ? void 0 : category.subCategories) === null || _a === void 0 ? void 0 : _a.length); })) || {};
    let isShipperReasonCodes = !_.isEmpty(shipperReasonCodes);
    return Object.assign(Object.assign({}, stop), { isShipperReasonCodes, reasonCodes: isShipperReasonCodes ? shipperReasonCodes : defaultReasonCodes });
}
function findCurrentStage(action) {
    switch (action) {
        case 'pickup':
            return 'PRIOR_TO_PICKUP';
        case 'deliver':
            return 'PRIOR_TO_DELIVERY';
        default:
    }
}
async function attachMissingReferenceNumbersByShipment(stop) {
    var _a, _b;
    try {
        const { job_id: _id, action, empty, shipment_type, shipper_id: shipper, reference_numbers, } = stop;
        const isEmpty = empty ? '_empty' : '';
        const movement = `${action}${isEmpty}`;
        const stage = findCurrentStage(movement);
        const _c = (await getMissingReferenceNumbers({
            _id,
            action,
            shipment_type,
            shipper,
            reference_numbers,
        })).entity.result, { present: _present } = _c, missingReferenceNumbers = __rest(_c, ["present"]);
        const shipmentMissingReferenceNumbers = (_b = (_a = missingReferenceNumbers[stage]) === null || _a === void 0 ? void 0 : _a.missing) !== null && _b !== void 0 ? _b : [];
        return Object.assign(Object.assign({}, stop), { missingReferenceNumbers: shipmentMissingReferenceNumbers });
    }
    catch (e) {
        console.error('Error getting missing reference numbers: ', e);
        return [];
    }
}
async function addShipperSpecificDataToStops(stopGroups, stopCategory) {
    const updatedStopGroups = stopGroups.map((stop) => addReasonCodesToStops(stop, stopCategory));
    if (!featureEnabled(CONFIGURED_FEATURES.SSR)) {
        return updatedStopGroups;
    }
    return Promise.all(updatedStopGroups.map(async (stop) => {
        return await attachMissingReferenceNumbersByShipment(stop);
    }));
}
const findStopKey = (stop, statusKey = 'stop_status') => {
    let key = 'nonArrivalStops';
    if ((stop.shipper_tags || []).includes(REQUIRES_ARRIVAL_INFO) &&
        stop[statusKey] === 'unstarted') {
        key = 'arrivalStops';
    }
    return key;
};
async function groupStops(currentState) {
    const stops = await getNextStops(currentState);
    /** Split the stops based on tag and status of stop. */
    let stopsMap = stops.reduce(function (obj, stop) {
        const key = findStopKey(stop);
        obj[key].push(stop);
        return obj;
    }, { nonArrivalStops: [], arrivalStops: [] });
    const { arrivalStops, nonArrivalStops } = stopsMap;
    const pickupEmptyStops = getPickupEmptyStops(nonArrivalStops);
    const pickupStops = getPickupStops(nonArrivalStops);
    const deliverEmptyStops = getDeliverEmpty(nonArrivalStops);
    const deliverStops = getDeliverStops(nonArrivalStops);
    const offsitePickupStops = getOffsitePickupStops(nonArrivalStops);
    const offsiteDeliverStops = getOffsiteDeliverStops(nonArrivalStops);
    const offsiteEmptyPickupStops = getOffsitePickupEmptyStops(nonArrivalStops);
    const offsiteEmptyDeliverStops = getOffsiteDeliverEmptyStops(nonArrivalStops);
    const pickupArrivalStops = getPickupStops(arrivalStops);
    const deliverArrivalStops = getDeliverStops(arrivalStops);
    const pickupEmptyArrivalStops = getPickupEmptyStops(arrivalStops);
    const deliverEmptyArrivalStops = getDeliverEmpty(arrivalStops);
    const offsitePickupArrivalStops = getOffsitePickupStops(arrivalStops);
    const offsiteDeliverArrivalStops = getOffsiteDeliverStops(arrivalStops);
    const offsitePickupEmptyArrivalStops = getOffsitePickupEmptyStops(arrivalStops);
    const offsiteDeliverEmptyArrivalStops = getOffsiteDeliverEmptyStops(arrivalStops);
    const groups = [];
    const defaultGroup = {
        saveInProgress: false,
        status: [],
    };
    if (pickupArrivalStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'pickup_arrival', stops: await addShipperSpecificDataToStops(pickupArrivalStops, 'stop_arrival') }));
    }
    if (pickupEmptyArrivalStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'pickup_empty_arrival', stops: await addShipperSpecificDataToStops(pickupEmptyArrivalStops, 'stop_arrival') }));
    }
    if (offsitePickupArrivalStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'offsite_pickup_arrival', stops: await addShipperSpecificDataToStops(offsitePickupArrivalStops, 'stop_arrival') }));
    }
    if (offsitePickupStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'offsite_pickup', stops: await addShipperSpecificDataToStops(offsitePickupStops, 'stop_complete') }));
    }
    if (pickupEmptyStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'pickup_empty', stops: await addShipperSpecificDataToStops(pickupEmptyStops, 'stop_complete') }));
    }
    if (offsitePickupEmptyArrivalStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'offsite_pickup_empty_arrival', stops: await addShipperSpecificDataToStops(offsitePickupEmptyArrivalStops, 'stop_arrival') }));
    }
    if (offsiteEmptyPickupStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'offsite_empty_pickup', stops: await addShipperSpecificDataToStops(offsiteEmptyPickupStops, 'stop_complete') }));
    }
    if (pickupStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'pickup', stops: await addShipperSpecificDataToStops(pickupStops, 'stop_complete') }));
    }
    if (deliverArrivalStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'deliver_arrival', stops: await addShipperSpecificDataToStops(deliverArrivalStops, 'stop_arrival') }));
    }
    if (offsiteDeliverArrivalStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'offsite_deliver_arrival', stops: await addShipperSpecificDataToStops(offsiteDeliverArrivalStops, 'stop_arrival') }));
    }
    if (deliverEmptyArrivalStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'deliver_empty_arrival', stops: await addShipperSpecificDataToStops(deliverEmptyArrivalStops, 'stop_arrival') }));
    }
    if (offsiteDeliverEmptyArrivalStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'offsite_deliver_empty_arrival', stops: await addShipperSpecificDataToStops(offsiteDeliverEmptyArrivalStops, 'stop_arrival') }));
    }
    if (offsiteEmptyDeliverStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'offsite_empty_deliver', stops: await addShipperSpecificDataToStops(offsiteEmptyDeliverStops, 'stop_complete') }));
    }
    if (offsiteDeliverStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'offsite_deliver', stops: await addShipperSpecificDataToStops(offsiteDeliverStops, 'stop_complete') }));
    }
    if (deliverEmptyStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'deliver_empty', stops: await addShipperSpecificDataToStops(deliverEmptyStops, 'stop_complete') }));
    }
    if (deliverStops.length) {
        groups.push(Object.assign(Object.assign({}, defaultGroup), { action: 'deliver', stops: await addShipperSpecificDataToStops(deliverStops, 'stop_complete') }));
    }
    return groups;
}
function toggleApplyAllDisabled(bulkAction) {
    const isApplyAllDisabled = getApplyAllDisabled(bulkAction);
    return (stop) => (Object.assign(Object.assign({}, stop), { meta: Object.assign(Object.assign({}, stop.meta), { applyAllDisabled: isApplyAllDisabled(stop) }) }));
}
function getArrivalDefaultDate(stop) {
    const { window_start, window_end } = stop;
    return window_start && window_end && moment().isAfter(window_end)
        ? moment(window_start).tz(getTimezoneHelper(stop))
        : moment().tz(getTimezoneHelper(stop));
}
function getCompleteDefaultDate(stop) {
    const { window_end } = stop;
    return window_end && moment().isAfter(window_end)
        ? moment(window_end).subtract(5, 'minutes').tz(getTimezoneHelper(stop))
        : moment().tz(getTimezoneHelper(stop));
}
function getApplyAllDisabled(bulkAction) {
    return (stop) => {
        let applyAllDisabled;
        switch (bulkAction) {
            case massUpdateActions.COMPLETE_STOP:
                applyAllDisabled =
                    !stop.meta.uri && !stop.meta.date && !stop.meta.signatory;
                break;
            case massUpdateActions.UPDATE_APPOINTMENT_WINDOW:
                applyAllDisabled = !stop.meta.window_start && !stop.meta.window_end;
                break;
            default:
                applyAllDisabled = true;
        }
        return applyAllDisabled;
    };
}
function resetMetadata(stop) {
    const timezone = getTimezone(stop);
    return Object.assign(Object.assign({}, stop), { meta: Object.assign(Object.assign({}, stop.meta), { uri: '', filePath: '', signatory: '', date: findStopKey(stop) === 'arrivalStops'
                ? getArrivalDefaultDate(stop)
                : getCompleteDefaultDate(stop), timezone: timezone, appointment: false, window_start: null, window_end: null, applyAllDisabled: true, confirm_appointment: false, message: '', reasonType: {}, reasonCode: {} }), dateChanged: false, status: {} });
}
export default withTranslation()(MassUpdateModal);
